import { useUploadStore } from '../store/uploadStore';
import { useAppStore } from '../store/appStore';

/**
 * Hook that wraps an action with a guard to prevent accidental navigation away
 * if there are unsaved GCP form changes or ongoing uploads.
 *
 * If the user attempts to leave with unsaved GCP changes or uploads in progress,
 * a confirmation modal will be shown instead of executing the action immediately.
 *
 * @returns A higher-order function that wraps an unsafe action with GCP leave protection.
 */
export const useGuardUnsavedGcp = () => {
  const { selectedMission, openGcpLeaveModal } = useAppStore();
  const { hasGcpFormChanges, hasGcpUploadingFiles } = useUploadStore();

  // Determine whether there are any unsaved GCP changes or uploads in progress
  const hasUnsaved =
    selectedMission &&
    (hasGcpFormChanges(selectedMission.customer.id, selectedMission.site.id) ||
      hasGcpUploadingFiles(selectedMission.customer.id, selectedMission.site.id));

  return (unsafeAction: () => void) => {
    return () => {
      if (hasUnsaved) {
        openGcpLeaveModal(unsafeAction);
      } else {
        unsafeAction();
      }
    };
  };
};
